import { useMutation, useQueryClient } from "@tanstack/react-query";
import { FinancialStatementView } from "../api/dto/FinancialStatement";
import { useSlimFinancial } from "../context/SlimFinancialProvider";
import { useNavigate } from "react-router-dom";

const saveKeys = {
  root: ["financialStatement"] as const,
  current: (partyId: string | number | undefined) =>
    [...saveKeys.root, partyId ?? "anon"] as const,
};

export function useSaveFinancialMutation(partyId?: string | number) {
  const { saveFinancial } = useSlimFinancial();
  const qc = useQueryClient();
  const navigate = useNavigate();

  return useMutation({
    mutationKey: saveKeys.current(partyId),
    mutationFn: async (input: Omit<FinancialStatementView, "totals"> ) => {
      await saveFinancial.execute(input);
    },
    onSuccess: async () => {
      // Invalidate so fresh data is available straight away
      await qc.invalidateQueries({ queryKey: saveKeys.current(partyId) });
      navigate("/sfs?mode=review");
    },
  });
}
